import { render, staticRenderFns } from "./InlineFlyerSelector.vue?vue&type=template&id=c8bc311a&"
import script from "./InlineFlyerSelector.vue?vue&type=script&lang=js&"
export * from "./InlineFlyerSelector.vue?vue&type=script&lang=js&"
import style0 from "./InlineFlyerSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports